//#region src/assets/Images/constants.ts
var DEFAULT_IMAGE_URLS = {
	LOCATION_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/location-placeholder.png",
	LOGO_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/logo-placeholder-image.png",
	RECORD_PERSON_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/record-person-placeholder.png",
	RECORD_PROPERTY_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/record-property-placeholder.png",
	RECORD_VEHICLE_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/record-vehicle-placeholder.png",
	USER_PROFILE_PLACEHOLDER: "https://therms.s3.us-west-2.amazonaws.com/images/avatar-placeholder.png"
};
//#endregion
export { DEFAULT_IMAGE_URLS };

//# sourceMappingURL=constants.js.map